"use client";

import CartPreview from "@/app/components/pages/cart/CartPreview";
import styles from "@/app/styles/components/pages/cart/delivery-details.module.scss";
import CartProcessStep from "@/app/constants/CartProcessStep";
import {FormattedMessage} from "react-intl";
import DeliveryForm from "@/app/components/pages/cart/DeliveryForm";
import {useSelector} from "react-redux";
import {canContinueToSenderData} from "@/app/utils/CartUtil";

const DeliveryDetails = ({data, products, cart, changeStep, agreed, setAgreed}) => {
    const cartData = useSelector((state) => state.cart?.data);

    const handleBack = () => {
        changeStep(CartProcessStep.CART);
    };

    const handleContinue = () => {
        changeStep(CartProcessStep.SENDER);
    };

    // const canContinue = () => {
    //     return (
    //         cartData &&
    //         cartData.deliveryData &&
    //         cartData.deliveryData.first_name &&
    //         cartData.deliveryData.last_name &&
    //         cartData.deliveryData.email &&
    //         cartData.deliveryData.phone &&
    //         cartData.deliveryData.address_1 &&
    //         cartData.deliveryData.city &&
    //         cartData.deliveryData.postcode &&
    //         cartData.deliveryData.note &&
    //         cartData.deliveryData.date &&
    //         cartData.deliveryData.time
    //     );
    // };

    return <div className={styles.wrapper}>
        <div className={styles.item}>
            <DeliveryForm/>
        </div>
        <div className={styles.item}>
            <CartPreview data={data}
                         products={products}
                         cart={cart}
                         canContinue={canContinueToSenderData(cartData)}
                         backText={<FormattedMessage id={'components.pages.cart.deliveryDetails.bacToCart'}/>}
                         handleBack={handleBack}
                         handleContinue={handleContinue}
                         continueTitle={<FormattedMessage
                             id={'components.pages.cart.deliveryDetails.continueToSender'}/>}
                        agreed={agreed}
                        setAgreed={setAgreed}
            />
        </div>
    </div>
};

export default DeliveryDetails;
